import { lazy } from "react";
import { connect } from "react-redux";
import { loading } from "../../../../store/administration/selectors/concept_types";

const NewConceptType = lazy(() => import("./NewConceptType"));

const mapStateToProps = (state) => ({
  loading: loading(state),
});

export default connect(mapStateToProps)(NewConceptType);
